import { Loader2 } from "lucide-react";

import { cn } from "./cn";

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn("h-4 w-4 animate-spin", className)} aria-hidden />;
}

export function FullScreenLoader({ label }: { label?: string }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-muted">
      <Spinner className="h-6 w-6 text-brand" />
      {label ? <p className="text-sm">{label}</p> : null}
    </div>
  );
}
